import React from 'react';
import styles from './style.module.scss';

export default function AboutUsFooter() {
  return (
    <div className={styles.footer}>
      <div className={styles.container}>
        <h2>Media Inquiries</h2>
        <p>For media inquiries, please contact <a href="mailto:communications@zoocasa.com">communications@zoocasa.com</a></p>
        <h2>Contact Us</h2>
        <div className={styles.contacts}>
          <div className={styles.contact}>
            <h4>Canada</h4>
            <p>250 The Esplanade</p>
            <p>Suite 408</p>
            <p>Toronto, ON M5A 4J5</p>
            <p className={styles.phone}><a href="tel:18446834663">1-844-683-4663</a></p>
            <p><a href="mailto:info@zoocasa.com">info@zoocasa.com</a></p>
          </div>
          <div className={styles.contact}>
            <h4>U.S.</h4>
            <p>2219 Rimland Drive</p>
            <p>Suite 301</p>
            <p>Bellingham, Washington, 98226</p>
            <p className={styles.phone}><a href="tel:18333030610">1-833-303-0610</a></p>
            <p><a href="mailto:info@exprealty.net">info@exprealty.net</a></p>
          </div>
        </div>
      </div>
    </div>
  );
}
